import { render, staticRenderFns } from "./TaggedArc.vue?vue&type=template&id=6b688209&"
import script from "./TaggedArc.vue?vue&type=script&lang=js&"
export * from "./TaggedArc.vue?vue&type=script&lang=js&"
import style0 from "./TaggedArc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TaggedArc.vue"
export default component.exports